
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { EventEditForm } from "@/components/event-details/EventEditForm";
import { EventView } from "@/components/event-details/EventView";
import { GuestEventView } from "@/components/event-details/GuestEventView";
import { Layout } from "@/components/Layout";
import { useEventDetails } from "@/hooks/use-event-details";

const EventDetails = () => {
  const { eventId } = useParams();
  const [isEditing, setIsEditing] = useState(false);
  const [editedEvent, setEditedEvent] = useState<any>(null);
  
  const {
    event,
    isLoading,
    updateMutation,
    removeGuest,
    isRemoving,
    isHost,
    rsvpStatus,
    refetchEvent
  } = useEventDetails(eventId!);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleEdit = () => {
    setEditedEvent(event);
    setIsEditing(true);
  };

  const handleSave = async () => {
    updateMutation.mutate(editedEvent, {
      onSuccess: () => setIsEditing(false)
    });
  };

  const handleCancel = () => {
    setIsEditing(false);
    setEditedEvent(null);
  };

  const handleRemoveGuest = async (userId: string) => {
    try {
      await removeGuest(userId);
      // No need to manually refetch - the query invalidation in useAttendeeRemoval will handle this
    } catch (error) {
      console.error("Error removing guest:", error);
    }
  };

  if (isLoading) {
    return <Layout bottomPadding={false}>
        <div className="min-h-screen p-4">
          <div className="animate-pulse space-y-4">
            <div className="h-8 bg-gray-200 rounded w-1/4"></div>
            <div className="h-4 bg-gray-200 rounded w-3/4"></div>
            <div className="h-4 bg-gray-200 rounded w-1/2"></div>
          </div>
        </div>
      </Layout>;
  }

  if (!event) {
    return <Layout bottomPadding={false}>
        <div className="min-h-screen p-4">
          <p>Event not found</p>
        </div>
      </Layout>;
  }

  if (!isHost && !isEditing) {
    return <Layout bottomPadding={false}>
        <GuestEventView 
          event={event} 
          rsvpStatus={rsvpStatus} 
          onRemoveGuest={undefined}
        />
    </Layout>;
  }

  return <Layout hideNav={isEditing} bottomPadding={false}>
      {isEditing ? (
        <div className="px-4 pt-4 pb-24">
          <EventEditForm 
            event={editedEvent} 
            onChange={setEditedEvent} 
            onSave={handleSave} 
            onCancel={handleCancel} 
            isSaving={updateMutation.isPending} 
          />
        </div>
      ) : (
        <EventView 
          event={event} 
          isHost={isHost} 
          onEditClick={handleEdit} 
          onRemoveGuest={handleRemoveGuest} 
          rsvpStatus={rsvpStatus}
        />
      )}
    </Layout>;
};

export default EventDetails;
